import { render, staticRenderFns } from "./downloadView.vue?vue&type=template&id=1beec66c&scoped=true"
import script from "./downloadView.vue?vue&type=script&lang=js"
export * from "./downloadView.vue?vue&type=script&lang=js"
import style0 from "./downloadView.vue?vue&type=style&index=0&id=1beec66c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1beec66c",
  null
  
)

export default component.exports